var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgActivityShelfLife = function SvgActivityShelfLife(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.25,
    height: 15.438,
    viewBox: "0 0 15.25 15.438"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 15.25,
    height: 15.438,
    x: 722,
    y: 282,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#403f40",
    result: "flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    operator: "in",
    result: "composite"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "SourceGraphic",
    result: "blend"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M729.62 282a7.726 7.726 0 1 0 7.624 7.725A7.674 7.674 0 0 0 729.62 282Zm2.953 10.068-3.64-1.7V284h1.376v5.481l2.839 1.322Z",
    "data-name": "shelf life",
    style: {
      fill: "#4da5b5",
      fillRule: "evenodd",
      filter: "url(#a)"
    },
    transform: "translate(-722 -282)"
  }));
};
export default SvgActivityShelfLife;